import React, {Component} from "react";
import {Input} from "reactstrap";
import {connect} from "react-redux";
import departmentSettingsSelectors from "../../store/department-settings/selectors";
import './DashboardOitSelect.scss'
import Checkbox from "../../../shared/forms/Checkbox";
import oitsActionCreators from "../../store/oits/action-creators/index";

class DashboardOitSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAllOits: false
    }
  }

  isTrainingCompleted(trainingTracker, trainingPhases) {
    return (trainingTracker
        && trainingTracker.status === 'closed')
      || (trainingPhases.length > 0 && trainingPhases.filter((phase) => phase.status === 'completed').length === trainingPhases.length)
  }
  filterOit(oit) {

    return (
      oit.trainingTracker && (oit.trainingTracker.status === 'opened' || oit.trainingTracker.status === 'paused' || !oit.trainingTracker.status)
    ) && !this.isTrainingCompleted(oit.trainingTracker, oit.trainingPhases);
  }

  updateShowAllOits(val) {
    if(val) {
      this.props.loadOitsContainer('all')
    }
    this.setState({
      showAllOits: val
    })
  }

  get oitsInProgress() {
    if(this.state.showAllOits) {
      return this.props.oits
    }
    return this.props.oits
      && this.props.oits.filter(this.filterOit.bind(this))
  }

  get selected() {
    if(this.props.multiple) {
      return this.props.value || []
    }

    return this.props.value
  }

  get value() {
    if(this.props.multiple) {
      return this.props.expanded || !this.props.value? '': this.props.value[0]
    }

    return this.props.value
  }

  get defaultLabel() {
    if(this.props.multiple) {
      return this.selected.length? `Add ${ this.props.oitShortLabel} for compare`: 'Select ' + this.props.oitShortLabel
    }

    return 'Select ' + this.props.oitShortLabel;
  }

  setSelectedOit(oitGuid) {
    if(this.props.multiple) {
      if(!this.props.expanded) {
        this.props.onInput([oitGuid])
      } else if(!this.selected.find(guid => guid === oitGuid)) {
        this.props.onInput([...this.selected, oitGuid])
      }
    } else {
      this.props.onInput(oitGuid)
    }
  }
  getOit(oitGuid) {
    return this.oitsInProgress.find(oit => oit.guid === oitGuid)
  }

  removeOit(oitGuid) {
    this.props.onInput(this.props.value.filter(guid => guid !== oitGuid))
  }

  get selectedOits() {
    return this.props.value ? this.props.value.map((oitGuid) => this.getOit(oitGuid)): []
  }
  render() {
    return (
     <div>
       <div className="dashboard-oit-select">
         {this.props.expanded && (
           <div className="select-label">{this.defaultLabel}</div>
         )}
         <Input
           name="type"
           onChange={event =>
             this.setSelectedOit(event.target.value)
           }
           type="select"
           className="select"
           value={this.value}
         >
           <option defaultValue={''}>{this.defaultLabel}</option>
           {this.oitsInProgress && this.oitsInProgress.map(oit => (
             <option key={oit.guid} value={oit.guid}>{oit.getFullName()}</option>
           ))}
         </Input>
         {this.props.children}

         {this.props.expanded && this.props.multiple && this.selectedOits.map(oit => (
           <div className="oit-badge" key={oit.guid} onClick={() => this.removeOit(oit.guid)}>
             <i className="fa fa-times"></i>
             {oit.getFullName()}
           </div>
         ))}
       </div>
       {this.props.expanded && <div>
         <Checkbox checked={this.state.showAllOits} onChange={(e) => this.updateShowAllOits(e.target.checked)}
                   label={'Show all ' + this.props.oitShortLabel + 's'}/>
       </div>}
     </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    oits: state.oits.list,
    departmentSettings: state.departmentSettings.settings,
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state),
    userContext: state.common.userContext
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadOitsContainer: (status) => {
      return dispatch(oitsActionCreators.loadOitsContainer(null, 'all'));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(DashboardOitSelect)
